module.exports = __webpack_public_path__ + "img/new-tournaments-320.6b18226c.png";